import React, { isValidElement } from 'react'
import Typography from '../../Typography'
import styles from './index.module.css'
import { findOneByName } from '@s4l/utils/library/react'

interface ILabelProps {
  children: React.ReactNode
}

const Label = ({ children }: ILabelProps) => {
  const childrenArray = React.Children.toArray(children)

  const inputElement = findOneByName(childrenArray, 'Form.Input')

  const textContent = childrenArray.filter(
    child => typeof child === 'string' || (isValidElement(child) && typeof child.type === 'string')
  )

  const nonTextElements = childrenArray.filter(
    child => typeof child !== 'string' && !(isValidElement(child) && typeof child.type === 'string')
  )

  if (inputElement) {
    return (
      <div className={styles.floatingLabel}>
        {inputElement}
        <label className={styles.floatingLabelText}>
          <Typography as="span" variant="body" size="l">
            {textContent}
          </Typography>
        </label>
      </div>
    )
  }

  return (
    <label className={styles.label}>
      {nonTextElements}
      <Typography as="span" variant="body" size="l">
        {textContent}
      </Typography>
    </label>
  )
}

Label.displayName = 'Form.Label'
export default Label
